import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { IReportFilters } from '../../../commons/interfaces/report.interface';
import PlaceholderFilterSection from './placeholder';
import './style.scss';

interface FilterSectionProps {
  filters?: IReportFilters;
  loading: boolean;
}

interface FiltersType {
  unitId?: string;
  requestTypeId?: string;
  status?: string;
}

enum FiltersEnum {
  units = 'unitId',
  statuses = 'status',
  ticketStatuses = 'status'
}

enum FiltersPlaceholderEnum {
  units = 'Unidades',
  statuses = 'Estado',
  ticketStatuses = 'Estado'
}

type FiltersEnumType = 'units' | 'statuses' | 'ticketStatuses';

const FilterSection = ({ loading, filters }: FilterSectionProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentFilters, setCurrentFilters] = useState<FiltersType>({});
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  useEffect(() => {
    const newCurrentFilters: FiltersType = {};

    _.forEach(filters, (_filter, filterKey) => {
      const filterEnum = FiltersEnum[filterKey as FiltersEnumType];
      newCurrentFilters[filterEnum] = searchParams.get(filterEnum) || '';
    });

    setStartDate(searchParams.get('startDate') || '');
    setEndDate(searchParams.get('endDate') || '');

    setCurrentFilters(newCurrentFilters);
  }, [searchParams, filters]);

  const updateSearchParams = (
    newFilters: FiltersType,
    newStartDate: string,
    newEndDate: string
  ) => {
    const params: Record<string, string> = {
      ...newFilters
    };

    if (newStartDate) {
      params.startDate = newStartDate;
    }

    if (newEndDate) {
      params.endDate = newEndDate;
    }
    setSearchParams(params);
  };

  const handleFilterChange = (type: string, ev: any) => {
    const changedValue = ev.target.value;

    const newCurrentFilter = { ...currentFilters, [type]: changedValue };

    setCurrentFilters(newCurrentFilter);
    updateSearchParams(newCurrentFilter, startDate, endDate);
  };

  const handleDateChange = (type: 'startDate' | 'endDate', value: string) => {
    const newStartDate = type === 'startDate' ? value : startDate;
    const newEndDate = type === 'endDate' ? value : endDate;

    if (type === 'startDate') setStartDate(value);
    if (type === 'endDate') setEndDate(value);

    updateSearchParams(currentFilters, newStartDate, newEndDate);
  };

  const renderSelects = () => {
    return _.map(filters, (filter, filterKey) => {
      const filterEnum = FiltersEnum[filterKey as FiltersEnumType];
      return (
        <Col key={filterKey} xs="auto">
          <Form.Select
            value={currentFilters[filterEnum]}
            onChange={handleFilterChange.bind(null, filterEnum)}>
            <option value="">{FiltersPlaceholderEnum[filterKey as FiltersEnumType]}</option>
            {_.map(filter, (filterOption) => (
              <option key={filterOption.id} value={filterOption.id}>
                {filterOption.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      );
    });
  };

  return (
    <Row className="filter-section align-items-center">
      <Col xs={1} className="align-self-center">
        Filtros
      </Col>
      {loading ? (
        <PlaceholderFilterSection />
      ) : (
        <>
          {renderSelects()}
          <Col xs="auto" className="d-flex align-items-center">
            <Form.Label className="mb-0 me-2">Fecha de cierre inicio</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => handleDateChange('startDate', e.target.value)}
              placeholder="Fecha de inicio"
              size="sm"
            />
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            <Form.Label className="mb-0 me-2">Fecha de cierre fin</Form.Label>
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => handleDateChange('endDate', e.target.value)}
              placeholder="Fecha de fin"
              size="sm"
            />
          </Col>
        </>
      )}
    </Row>
  );
};
export default FilterSection;
